<template>
  <v-container
    fluid
    fill-height
    grid-list-md
    class="welcome-container"
  >
    <v-layout
      row
      justify-center
      align-center
    >
      <v-slide-y-transition mode="out-in">

        <welcome-first-page
          v-if="pageContent === 'first-page'"
          :title="title"
          @showAgencyForm="showAgencyForm"
        />
        <welcome-agency-form
          v-if="pageContent === 'agency-form'"
          :title="title"
          @setAgency="setAgency"
        />
        <welcome-second-page
          v-if="pageContent === 'second-page'"
          :title="title"
          @setAdvertiserType="setAdvertiserType"
        />
        <welcome-third-page
          v-if="pageContent === 'third-page'"
          :agency="agency"
          :title="title"
          @setCampaign="setCampaign"
        />
        <welcome-congrats-page
          v-if="pageContent === 'congrats'"
          :title="title"
        />
        <v-card v-if="pageContent === 'stepper'" max-width="600">
          <v-toolbar class="ou-toolbar">
            <v-toolbar-title class="ou-toolbar-text">Welcome to Outfox AI</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
          <v-stepper v-model="page">
              <v-stepper-header>
                <v-stepper-step :complete="page > 1" step="1" editable>Campaign info</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="page > 2" step="2" editable>Your info</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3" editable>Your accounts</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <stepper-conten-one
                    @setAdvertiser="setAdvertiser"
                    :title="title"
                    :existingCampaign="existingCampaign"
                    :advertiserType="advertiserType"
                  />
                </v-stepper-content>
                <v-stepper-content step="2">
                  <stepper-conten-two
                    :title="title"
                    :agency="agency"
                    :advertiser="advertiser"
                    :existingCampaign="existingCampaign"
                    @setPage="setPage"
                  />
                </v-stepper-content>
                <v-stepper-content step="3">
                  <stepper-conten-three
                    :title="title"
                    :newClientCreating="newClientCreating"
                    :existingCampaign="existingCampaign"
                    @setPage="setPage"
                    @showCongrats="showCongrats"
                  />
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
        </v-card>

      </v-slide-y-transition>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import lodash from 'lodash'
  import WelcomeFirstPage from './TheWelcomeFirstPage'
  import WelcomeSecondPage from './TheWelcomeSecondPage'
  import WelcomeThirdPage from './TheWelcomeThirdPage'
  import StepperContenOne from './stepper-content/StepperContentOne.vue'
  import StepperContenTwo from './stepper-content/StepperContentTwo.vue'
  import StepperContenThree from './stepper-content/StepperContentThree.vue'
  import WelcomeAgencyForm from './TheWelcomeAgencyForm'
  import WelcomeCongratsPage from './WelcomeCongratsPage'

  export default {
    name: 'welcome',
    components: {
      WelcomeFirstPage,
      WelcomeSecondPage,
      WelcomeThirdPage,
      StepperContenOne,
      StepperContenTwo,
      StepperContenThree,
      WelcomeAgencyForm,
      WelcomeCongratsPage
    },
    data () {
      return {
        page: 0,
        pageContent: 'first-page',
        existingCampaign: null,
        agency: null,
        advertiser: null,
        advertiserType: 'political_campaign'
      }
    },
    props: {
      greyBackground: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Welcome to Outfox AI'
      },
      newClientCreating: {
        type: Boolean,
        default: false
      }
    },
    mounted () {
      this.$store.dispatch('fetchAdvertisers')
    },
    computed: {
      ...mapGetters({
        agencies: 'getAgencies'
      })
    },
    methods: {
      setPage (page) {
        this.page = page
      },
      setAdvertiser (advertiser) {
        if (this.agency) {
          const agency = this.agencies.find(a => a.id === this.agency)
          const clone = lodash.cloneDeep(agency)
          clone.data.advertisers.push(advertiser)
          this.$store.dispatch('updateAgency', clone)
        }
        this.advertiser = advertiser
        this.page = 2
      },
      showCongrats () {
        this.pageContent = 'congrats'
      },
      showAgencyForm (show) {
        if (show) {
          this.pageContent = 'agency-form'
        } else {
          // Set second-page once more advertisers will be added
          this.pageContent = 'third-page'
        }
      },
      setAgency (agency) {
        this.agency = agency
        this.pageContent = 'third-page'
      },
      setAdvertiserType (advertiser) {
        this.advertiserType = advertiser
        this.pageContent = 'third-page'
      },
      setCampaign (campaign) {
        if (campaign) this.existingCampaign = campaign
        this.pageContent = 'stepper'
      }
    },
    watch: {
      path (val) {
        if (!val && !this.valid && this.$refs.form.validate()) {
          this.valid = false
        } else {
          this.valid = true
        }
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $toolbar-background: rgb(134, 188, 184);
  $background-grey: rgb(139, 139, 139);
  $color-title: rgb(255, 255, 255);

  .ou-toolbar {
    background-color: $toolbar-background!important;
  }
  .ou-toolbar-text {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
  }
  .welcome-container {
    background: $background-grey;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>
